import { useTranslation } from '@eti/providers';
import { price } from '@eti/utils';
import type { FilterType } from '@eti/schema-types';
import { PRICE } from '../../../../constants/searchFiltersConstants';
import type { SearchOnResultPagePriceRangeType } from '../../models';
import RangeSliderFilter from './RangeSliderFilter';
import type { Filters } from './v3/MobileFilters';

type PriceProps = {
  className: string;
  isInitiallyExpanded: boolean;
  isToggleable: boolean;
  onFilter: (filter: any) => void;
  range?: SearchOnResultPagePriceRangeType;
  selectedValues: Filters[typeof FilterType.Price];
};

const PriceSliderFilter = ({
  className,
  isInitiallyExpanded,
  isToggleable,
  onFilter,
  range,
  selectedValues,
}: PriceProps) => {
  const { t } = useTranslation();

  return (
    <RangeSliderFilter
      className={className}
      formatDisplayedValue={price.formatPrice}
      getPriceCurrencySRText={price.replaceWithCurrencyName}
      isInitiallyExpanded={isInitiallyExpanded}
      isToggleable={isToggleable}
      label={t('Result.SearchFilters.Price.Text')}
      maxValue={range?.max ?? 0}
      maxValueLabel={t('ScreenReader.Result.Filters.PriceSlider.MaximumPrice.Text')}
      minValue={range?.min ?? 0}
      minValueLabel={t('ScreenReader.Result.Filters.PriceSlider.MinimumPrice.Text')}
      name={PRICE}
      onFilter={onFilter}
      selectedValues={selectedValues}
    />
  );
};

export default PriceSliderFilter;
